import { downloadCsv } from './csvFile';

/** The CSV layout the import reads: a header row, then one client per row. Email may be left empty. */
export const SAMPLE_CSV = [
  'name,phone,email',
  'Tan Wei Ming,+65 9000 0001,wei.ming@example.test',
  'Siti Nurhaliza,+65 9000 0002,',
  'Rahul Menon,+60 12 000 0003,rahul.menon@example.test',
].join('\r\n');

export const MAX_CSV_BYTES = 1_000_000; // the server's limit, about 5,000 clients

/** Saves the sample as a file, so the RM starts from the right columns. */
export function downloadSampleCsv(): void {
  downloadCsv('client-list-sample.csv', SAMPLE_CSV);
}
